import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';
import {
    DialogFileBoxDialog,
    DialogFileBoxDialogAction,
    DialogFileBoxStepDialog,
    DialogFileBoxText,
    DialogFileDialogFiles,
} from 'assets/styles/modules/upload-documents/upload-packet/DialogFile';

/**
 * Represents the DialogFileUpload component.
 *
 * @param {DialogFileUploadProps} props - The component props.
 * @returns {ReactElement} - The rendered component.
 */
const DialogComplete = ({
    openDialogComplete,
    setOpenDialogComplete,
    confirmation,
}: DialogFormUpload): ReactElement => {
    // Actions
    const actionPositive = (): void => {
        setOpenDialogComplete(false);
        confirmation(true);
    };
    // const actionNegative = (): void => {
    //     setOpenDialogComplete(false);
    //     confirmation(false);
    // };

    return (
        <Box>
            <Dialog
                open={openDialogComplete}
                onClose={() => actionPositive()}
                maxWidth="md"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '39rem',
                    },
                }}
            >
                <DialogContent dividers sx={DialogFileDialogFiles}>
                    <Box className="DialogForm-ContentBox">
                        <Box sx={DialogFileBoxDialog}>
                            <TypographyLevel variant="two">
                                <Box>Upload completed</Box>
                                <Box>Waiting verification</Box>
                            </TypographyLevel>
                        </Box>

                        <Box sx={DialogFileBoxStepDialog}>
                            <TypographyLevel variant="four">
                                <Box sx={DialogFileBoxText}>
                                    Your cross check is on queue to be verified.{' '}
                                    <br />
                                    You can track the status on the manage cross
                                    check records tab
                                </Box>
                            </TypographyLevel>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions className="DialogFile-DialogAction">
                    <Box sx={DialogFileBoxDialogAction}>
                        {/* ACTION SHORTCUT  */}
                        {/* Action Negative - False */}
                        {/* <ButtonComp
                            width="16rem"
                            onClick={() => actionNegative()}
                            type="neutral"
                        >
                            Go back & Edit
                        </ButtonComp> */}

                        {/* Action Positive - True */}
                        <ButtonComp
                            width="16rem"
                            onClick={() => actionPositive()}
                            type="primary"
                        >
                            Confirm
                        </ButtonComp>
                    </Box>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default DialogComplete;
